import { useAmplitude, EventNamesMap } from 'src/context/AmplitudeProvider';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import useStoreSlug from 'src/common/hooks/useStoreSlug';
import { Address } from 'src/types/common';
import { CreateAddressParams } from 'src/features/addresses/domain/AddressesRepositoryInterface';
import { EditAddressRequestParams } from 'src/features/addresses/data/service/addressesService.types';

const useTrackAddressEvents = () => {
  const { user } = useAuthContext();
  const { userStoreSlug, isAvailable } = useStoreSlug();
  const { logEvent } = useAmplitude();

  const trackAddressCreate = (address: Address) => {
    if (user) {
      logEvent(EventNamesMap.CreateAddress, {
        email: user.email,
        address_id: address.pk,
        store_slug: address.store_data?.slug_name,
        is_store_available:
          !!address.store_data && userStoreSlug === address.store_data.slug_name
            ? isAvailable
            : undefined,
      });
    }
  };

  const trackAddressSelect = (address: Address) => {
    if (user) {
      logEvent(EventNamesMap.SelectAddress, {
        email: user.email,
        address_id: address.pk,
        store_slug: address.store_data?.slug_name,
        is_store_available:
          !!address.store_data && userStoreSlug === address.store_data.slug_name
            ? isAvailable
            : undefined,
      });
    }
  };

  const trackCreateAddressError = (addressParams: CreateAddressParams) => {
    if (user) {
      logEvent(EventNamesMap.CreateAddressError, {
        address: addressParams,
        email: user?.email,
      });
    }
  };

  const trackAddressEdit = (address: Address) => {
    if (user) {
      logEvent(EventNamesMap.EditAddress, {
        email: user.email,
        address_id: address.pk,
        store_slug: address.store_data?.slug_name,
        is_store_available:
          !!address.store_data && userStoreSlug === address.store_data.slug_name
            ? isAvailable
            : undefined,
      });
    }
  };

  const trackEditAddressError = (addressParams: EditAddressRequestParams) => {
    if (user) {
      logEvent(EventNamesMap.EditAddressError, {
        address: addressParams,
        email: user?.email,
      });
    }
  };

  return {
    trackAddressCreate,
    trackAddressSelect,
    trackCreateAddressError,
    trackAddressEdit,
    trackEditAddressError,
  };
};

export default useTrackAddressEvents;
